export default __webpack_public_path__ + "static/media/screen7.85a15fa0.png";